// frontend/src/pages/BossBattlesUnavailable.js
// Shown when a user reaches a Boss Battles route while `mode_boss_battle` is off.

import React from 'react';
import { Button } from '../components/ui';
import './BossBattlesUnavailable.css';

/**
 * The clean "not available" state for the Boss Battles / Fields of Valhalla routes.
 *
 * WHY THIS EXISTS: `currentScreen` persists in localStorage and both Boss Battles
 * routes are directly reachable, so hiding the entry points is NOT enough — a user
 * whose tab closed on `bossBattlesPage`, or who kept a bookmark, is restored
 * straight into the page with the flag off. Without this they hit
 * `BossBattlesPage`'s generic error panel showing a raw gate message, which reads
 * as a broken app rather than a mode that is switched off.
 *
 * WHY A SCREEN RATHER THAN A SILENT REDIRECT: bouncing a restored session
 * elsewhere with no explanation reads as the app losing the user's place — the
 * same reasoning as `SeasonPlayerUnavailable`. The copy deliberately does not
 * promise a date, and never mentions feature flags or staff visibility.
 *
 * This screen is reached by BOTH the pre-emptive route guard (flag read says
 * hidden) and the server's authoritative 404 gate envelope, so the two paths
 * cannot look different to the user.
 */
function BossBattlesUnavailable({ onBack }) {
    if (typeof onBack !== 'function') {
        throw new Error(
            '❌ BossBattlesUnavailable requires an onBack handler — this screen is a ' +
            'dead end without one.'
        );
    }

    return (
        <div className="boss-battles-unavailable" role="status">
            <h2 className="boss-battles-unavailable__title">
                Fields of Valhalla Is Closed
            </h2>
            <p className="boss-battles-unavailable__message">
                Boss Battles isn’t available right now. Your teams, leagues and
                everything else are unaffected — check back later.
            </p>
            <Button onClick={onBack} variant="secondary">
                Back to My Teams
            </Button>
        </div>
    );
}

export default BossBattlesUnavailable;
